import React from "react";
import { FaPlus } from "react-icons/fa";
import { RoundedQuestionBox } from "../RoundedQuestionBox";
import { AddQuestionBody } from "./AddQuestionBody";
import { QuestionOptionType } from "survey";
import { RatingQuestionFormValues } from "../Question/forms/RatingQuestionForm";
import { TextQuestionFormValues } from "../Question/forms/TextQuestionForm";
import { SelectQuestionFormValues } from "../Question/forms/SelectQuestionForm";

interface AddQuestionTileProps {
  options: QuestionOptionType[];
  onClick: (type: QuestionOptionType) => void;
  onSubmit: (data: RatingQuestionFormValues | TextQuestionFormValues | SelectQuestionFormValues) => Promise<void>;
}
export const AddQuestionTile = ({ onClick, onSubmit, options }: AddQuestionTileProps) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const onClickHandler = (type: QuestionOptionType) => {
    onClick(type);
    setIsOpen(false);
  };

  return (
    <div>
      <RoundedQuestionBox
        startIndex={<FaPlus />}
        indexCenter
        scaleOnHover
        color="emerald"
        isOpen={isOpen}
        onClick={() => setIsOpen((pv) => !pv)}
      >
        <div>
          <div className="text-black dark:text-white">Dodaj pytanie</div>
          <div className="text-xs text-gray-400">Dodaj kolejne pytanie do swojej ankiety</div>
        </div>
      </RoundedQuestionBox>
      {isOpen && <AddQuestionBody onClick={onClickHandler} options={options} />}
    </div>
  );
};
